export const NAV_STATE_LS_KEY = 'nav-platform-sidebar-state';

// Exporting this so they can be used in tests
export const DEFAULT_COLLAPSED_KEY = 'defaultCollapsed' as const;
export const DEFAULT_WIDTH_KEY = 'defaultWidth' as const;
